/* eslint-disable */ import { memoEval, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const lynxProfessionalCocktailStationComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'default', true).withEntity('LynxProfessionalCocktailStation').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'COCKTAIL_STATION_LYNX_LCS30',
            dimensionUnit: 'inch'
        })))
];

//# sourceMappingURL=lynx-professional-cocktail-station.js.map